import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { useNavigate } from '@reach/router';
import { useIsManager } from '../../hooks';

export const AxisFooter = () => {
  const navigate = useNavigate();
  const { isManager } = useIsManager();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        py: 2,
      }}
    >
      <Typography variant='caption' color='textSecondary'>
        <Link
          href='https://axisinsurance.ca/privacy-policy/'
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          underline='always'
        >
          Privacy Policy
        </Link>
      </Typography>
      <Typography
        variant='caption'
        color='textSecondary'
        sx={{ fontWeight: 600 }}
      >
        {!isManager ? (
          <Box
            component='span'
            onClick={() => navigate('/insurtech/manager/dashboard')}
            sx={{ cursor: 'text' }}
          >
            Powered
          </Box>
        ) : (
          'Powered'
        )}{' '}
        <Link
          color='primary'
          underline='none'
          href='https://calefy.ca/'
          target='_blank'
          rel='noopener noreferrer'
        >
          by Calefy
        </Link>
      </Typography>
    </Box>
  );
};
